import { derived } from 'svelte/store';

import { path } from '$lib/translations';
import { ƒ_photograph } from '$lib/routes';
import { yearMonthDaySlug, type PermalinkablePhotographRecord } from '$lib/domain/photograph';

export const photographPath = derived(path, ($path) => (photograph: PermalinkablePhotographRecord) => {
	const { year, month, day, slug } = yearMonthDaySlug(photograph);

	if (!year || !month || !day || !slug) throw `Not enough data to build the path! ${JSON.stringify(photograph)}`;

	return $path(ƒ_photograph, { year, month, day, slug });
});
